import {
  useCallback, ChangeEvent, ReactNode, memo,
} from 'react';
import Grid from '../../../Grid';
import Divider from '../../../Divider';
import Switch, { type ISwitchProps } from '../../../Switch';
import Typography from '../../../Typography';
import Tooltip from '../../../Tooltip';
import { S6 } from '../../../../theme';

interface IToggledSettingProps extends Omit<ISwitchProps, 'title' | 'onChange'> {
  title: string | ReactNode;
  name: string;
  description: string | ReactNode;
  onChange: (
    name: string, checked: boolean, event: ChangeEvent<HTMLInputElement>
  ) => void;
  tooltip?: ISwitchProps['title'];
}

const ToggledSetting = (props: IToggledSettingProps) => {
  const {
    title, name, description, onChange, tooltip, ...restSwitchProps
  } = props;

  const handleChange = useCallback<
    NonNullable<ISwitchProps['onChange']>
  >((event, checked) => {
    onChange(name, checked, event);
  }, [name, onChange]);

  return (
    <Grid container item flexDirection="row">
      <Grid item mt="3px" mr={1}>
        {/* Wrap Switch into Box for the case when we need to show a tooltip
        but Switch is in the disabled state */}
        <Tooltip title={tooltip ?? ''}>
          <Switch {...restSwitchProps} onChange={handleChange} />
        </Tooltip>
      </Grid>
      <Grid container item flex={1} flexDirection="column">
        <Grid item mb={0.5}>
          <Typography variant="subtitle1" color={S6}>{title}</Typography>
        </Grid>
        <Divider />
        <Grid item mt={1}>
          <Typography variant="body2" component="div" color={S6}>
            {description}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(ToggledSetting);
